import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import { cardsPerPage } from '../../utils/miscConstants';
import ResponsiveChipSkeleton from './ResponsiveChipSkeleton';
import DealsCardSkeleton from './DealsCardSkeleton';

export default function HealthyDealsSkeleton({ title, description = null }) {
	return (
		<>
			<Stack spacing={3} mb={5}>
				<Typography variant="h3" component="h1" gutterBottom color="primary">
					{title}
				</Typography>
				{description && (
					<Typography variant="body2" component="h2" gutterBottom>
						{description}
					</Typography>
				)}
			</Stack>
			<ResponsiveChipSkeleton />
			<Stack mt={2.25}>
				<Grid container spacing={2}>
					{Array.from(new Array(cardsPerPage)).map((_, index) => (
						// eslint-disable-next-line react/no-array-index-key
						<Grid item xs={12} sm={6} md={4} key={index}>
							<DealsCardSkeleton />
						</Grid>
					))}
				</Grid>
			</Stack>
		</>
	);
}

HealthyDealsSkeleton.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string,
};
